import { SmartDialog } from '../../../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import WidgetContainer from './WidgetContainer'
import { useEffect, useMemo, useState } from 'react'
import useMosInfo from '../common/provider/useMosInfo'
import { Typography } from '@mui/material'
import SmartSearch from '../../../generic/formComponent/Search'
import { WidgetProviders } from './WidgetProvider'

const SeletableWidget = ({ provider, onClick, w, h, columns, cellHeight }) => {
  const { device } = useMosInfo()
  return (
    <div onClick={onClick}>
      <WidgetContainer disabled title={provider.getName({})} icon={provider.getIcon({})} preview>
        {provider.createPreviewWidget({ w, h, data: provider.getDefaultConfiguration(), columns, cellHeight, device })}
      </WidgetContainer>
    </div>
  )
}

const WidgetListDialog = ({ open, setOpen, handleAdd, columns, cellHeight, showAll = false }) => {
  const { t_ } = useSmartTranslation()
  const { device } = useMosInfo()
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    if (open) {
      setSearchText('')
    }
  }, [open])

  const orderedProviders = useMemo(() => {
    let providers = [...Object.values(WidgetProviders)]

    // Without a selected device only widgets flagged as availableWithoutDevice
    // are offered, unless showAll is requested (e.g. editing a device layout
    // built from a template, where no MOS device context is loaded).
    if (!device && !showAll) {
      providers = providers.filter((provider) => {
        const info = provider.getWidgetInfo(columns, cellHeight)
        return info.availableWithoutDevice
      })
    }

    if (searchText && searchText.length > 0) {
      providers = providers.filter((item) => {
        return (t_(item.getName().toLowerCase()).indexOf(searchText.toLowerCase()) >= 0)
      })
    }

    return providers.sort((a, b) =>
      t_(a.getName({})).localeCompare(t_(b.getName({})))
    )
  }, [t_, device, showAll, cellHeight, columns, searchText])

  const columnsInDialog = 3
  return (
    <SmartDialog
      setOpen={open}
      closeCallback={() => setOpen(false)}
      title={{
        render:
        (
          <div style={{ width: '100%', display: 'flex', direction: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='h4'>{t_('Add new widget')}</Typography>
            <SmartSearch setLoadTable={() => {}} setFilterText={setSearchText} />
          </div>
        )
      }}// createDialogTitle({ color: 'primary', title: t_('Add new widget'), icon: WidgetsIcon })}
      close
      accept={false}
      cancel={false}
      renderComponent={
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columnsInDialog}, minmax(0, 1fr))`,
          gap: '1rem',
          padding: '1rem',
          gridAutoRows: '20rem'
        }}
        >
          {Object.values(orderedProviders).map((item) =>
            <SeletableWidget
              key={item.getName()}
              handleAdd={handleAdd}
              provider={item}
              columns={columns}
              cellHeight={cellHeight}
              onClick={() => {
                handleAdd(item)
                setOpen(false)
              }}
              w={Math.ceil(columns / columnsInDialog)}
              h={1}
            />)}
        </div>
      }
    />
  )
}

export default WidgetListDialog
